import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  DestroyRef,
  OnInit,
  inject,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { CheckboxState } from '@voyagu/portal-design-system';

@Component({
  selector: 'checkbox-field',
  templateUrl: './checkbox-field.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CheckboxFieldComponent extends FieldType<FieldTypeConfig> implements OnInit {
  changeDetectorRef = inject(ChangeDetectorRef);
  destroyRef = inject(DestroyRef);

  ngOnInit() {
    this.formControl.events
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => this.changeDetectorRef.markForCheck());
  }

  get checkboxState(): CheckboxState {
    if (this.formControl.disabled) {
      return 'disabled';
    }

    if (this.showError) {
      return 'error';
    }

    return 'default';
  }
}
